import { LitElement } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreRadioGroup } from "@slhuicore/radio-group";
import { SlhCoreFormElement } from "@slhuicore/base/form";
import { SlhFormIcons } from "@slhui/form-icons";
import { style } from "./assets/radio-group.generated-style";

/**
 * The slh-radio-group component is a simple group for slh-radio component.
 *
 * @CustomElement slh-radio-group
 *
 * @cssprop --slh-default-font-family - Radio group hint font family.
 * @cssprop --slh-base-xxs-font-size - Radio group hint font size.
 * @cssprop --slh-base-bold-font-weight - Radio group hint font weight.
 * @cssprop --slh-color-neutral-shade-60 - Radio group hint font color.
 * @cssprop --slh-base-xxs-line-height - Radio group hint line height.
 *
 * ** slots
 * @slot default - slh-radio component. Assigned slot nodes are parsed so that only slh-radio components are shown.
 * @slot label - slh-label component. Assigned slot nodes are parsed so that only slh-label components are shown.
 * @slot hint - Custom content below the radio group, designed to contain recommendations for user input.
 */
@customElement("slh-radio-group")
export default class SlhRadioGroup
  extends SlhCoreRadioGroup(LitElement)
  implements SlhCoreFormElement
{
  static styles = style;

  // eslint-disable-next-line class-methods-use-this
  private getHintIcon(): HTMLElement {
    return SlhFormIcons.getHintIcon();
  }
}
